import React from "react";
import PropTypes from "prop-types";
const stickyPolyfill = typeof window !== 'undefined' && window.document ? require('stickyfilljs')  : {};

class Sticky extends React.Component{
    static propTypes = {
        className: PropTypes.string,
        children:PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
        props:PropTypes.object,
        type:PropTypes.string,
        isSticky: PropTypes.bool,
        isAtBottom: PropTypes.bool,
        stickySelector:PropTypes.string
    }

    static defaultPropTypes = {
        isAtBottom: false
    }

    stickyRef;

    state = {
        style: {}
    }

    componentDidMount(){
        if(this.props.isAtBottom){
            const height = this.stickyRef.getBoundingClientRect().height;
            const top = `calc(100% - ${height}px)`;
            this.setState({style: {top}}, () =>{
                const stickyPolyfill = typeof window !== 'undefined' && window.document ? require('stickyfilljs')  : {};
                stickyPolyfill.addOne(this.stickyRef)})
            return;
        }
        if(this.props.isSticky){
            stickyPolyfill.addOne(this.stickyRef)
        }
    }

    render(){
        const {type,props,children} = this.props;
        return(React.createElement(type, {...props, ref:el => this.stickyRef = el, style:this.state.style},children))
    }
}

export default Sticky;


// WEBPACK FOOTER //
// ./src/components/Sticky/Sticky.jsx